<div *ngIf="notification" class="notification-bar" [ngClass]="notification?.msgType"><span>{{notification?.msg}}</span></div>
